export const word = {
    main: "Գլխավոր",
    yes: "Այո",
    no: "Ոչ",
    calculate: "Հաշվել",
    advantage: "Օգտվել",
    rejected: "Մերժված",
    save: "Պահպանել",
    working_calendar: "Աշխատանքային օրացույց",
    service: "Ծառայություններ",
    courses: "Դասընթացներ",
    about_us: "Մեր մասին",
    log_in: "Մուտք գործել",
    news: "Նորություններ",
    information: "Հետաքրքիր ինֆորմացիա",
    search: "Որոնում",
    blog: "Բլոգ",
    my_page: "Իմ էջը",
    legislation: "Օրենսդրություն",
    orderAservice: "Պատվիրել ծառայություն",
    registered: "Գրանցված",
    clean: "Մաքուր",
    consultation: "Ստանալ անվճար Խորհրդատվություն",
    request: "Կատարել հարցումը",
    our_service: "Մեր ծառայությունները",
    packages: "Հաշվապահական ծառայություններ",
    hc: "ՀԾ",
    oneC: "1C",
    seal_making: "Կնիքների պատրաստում",
    service_list: [
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsumhas been the industry's standard dummy text ever since the 1500sLorem Ipsum is simply dummy text of the printing and typesetting industry.",
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsumhas been the industry's standard dummy text ever since the 1500sLorem Ipsum is simply dummy text of the printing and typesetting industry.",
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsumhas been the industry's standard dummy text ever since the 1500sLorem Ipsum is simply dummy text of the printing and typesetting industry.",
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsumhas been the industry's standard dummy text ever since the 1500sLorem Ipsum is simply dummy text of the printing and typesetting industry.",
    ],
    see_more: "Տեսնել ավելին",
    accounting: "Հաշվապահական հաշվառում",
    banking: "Բանկային գործ",
    marketing_business: "Մարքեթինգային գործ",
    teach: "Ի՞նչ ենք սովորեցնում մենք",
    what_are_we_doing: "Ի՞նչ գործուներություն ենք ծավալում",
    why_are_we: "Ինչո՞ւ մենք",
    our_advantages: "Մեր առավելությունները",
    whats_new_with_us: "Ի՞նչ նորություններ կան մեր մոտ",
    what_can_we_see_here: "Ի՞նչ կարող ենք տեսնել այստեղ",
    // company:"Ընկերություն",
    registration: "Գրանցվել",
    login: "Մուտք Գործել",
    Create_a_new_account: "Ստեղծել նոր հաշիվ",
    personal_information: "Անձնական տվյալներ",
    organizations: "Կազմակերպություններ",
    _name: "Անուն՝",
    surname: "Ազգանուն՝",
    phone: "Հեռախոսահամար՝",
    email: "Էլեկտրոնային հասցե՝",
    document_type: "Փաստաթղթի տեսակը՝",
    document_number: "Փաստաթղթի համարը՝",
    data: "Տեղեկություն",
    recommendations: "Առաջադրանքներ",
    new_recommendations: "Ստեղծել նոր առաջադրանքներ",
    new_created: "Նոր ստեղծված",
    new_employee: "Նոր աշխատակից",
    add_new_employee: "Կցել նոր աշխատակից",
    add_new_org: "Ավելացնել նոր կազմակերպություն",
    new_organization: "Նոր կազմակերպություն ",
    in_the_process: "Ընթացքի մեջ",
    completed: "Ավարտված",
    approved: "Հաստատված",
    confirmed: "Հաստատել",
    add_picture: "Ավելացնել լուսանակար",
    add_organization: "Ավելացնել կազմակերպություն",
    add_header_picture: 'Ավելացնել շապիկի նկար',
    send: "Ուղարկել",
    // start:"Ստարտ",
    economy: "Էկոնոմ",
    standard: "Ստանդարտ",
    standard1: "Ստանդարտ+",
    classic: "Կալասիկ",
    price: "արժեքը՝",
    buy: "Գնել",
    manager_name: "Անուն Ազգանուն",
    log_out: "Դուրս գալ",
    stuff: "Աշխատակազմ",
    stuffs: "Կցված աշխատակիցները",
    my_organizations: "Կցված կազմակերպություններ",
    users: "Օգտատերեր",
    tasks: "Առաջադրանքներ",
    agentTasks: "Աշխատանքի առաջարկ",
    archive: "Արխիվ",
    periodically_repetitive_tasks: "Պարբերաբար կրկնվող Առաջադրանքներ",
    user_name: "Անուն ազգանուն",
    user_phone: "Հեռախոս",
    user_email: "էլեկտրոնային հասցե",
    task_name: "Առաջադրանքի անվանում",
    name_organization: "Կազմակերպության անվանում",
    performer_name: "Կատարողի անվանում",
    tasks_date: "Երբ է կատարվել",
    income_calculator: "Եկամտի հաշվիչ",
    org_name: "Կազմակերպության տվյալները",
    employees: "Աշխատակիցներ",
    add_archive: "Ուղարկել արխիվ",
    start: "Սկսել",
    complet: "Ավարտել",
    append: "Կցել",
    create: "Ստեղծել",
    company: "Ընտրել կազմակերպություն",
    accountant_file: "Հաշվապահական ֆայլեր",
    dayOff: "Day off-ի հարցում",
    accountant: "Ընտրել աշխատակից",
    manager: "Ընտրել մենեջեր",
    registMonth: "Գրանցման ամիս",
    registNumber: "Գրանցման համար",
    directorLastName: "Տնօրենի անուն ազգանուն",
    category: "Կարգավիճակ ՝ գործող կամ դադար",
    activityType: "Գործունեության տեսակ",
    taxationSystem: "Հարկման համակարգ",
    numberEmployees: "Աշխատակիցների քանակ",
    action: "Գործող",
    inoperative: "Չգործող",
    company_tasks: "Կազմակերպության առաջադրանքները",
    addItem: "Ավելացնել",
    selected_manager: "Ընտրել մենեջեր",
    HVHH: "ՀՎՀՀ",
    address: "Հասցե",
    note: "Նշումներ",
    delete_company: "Օգտատերը  ցանկանում է ջնջել կազմակերպությունը",
    email_error: "Պետք է լինի օրինակ mail@mail.ru",
    phone_error: "Պետք է լինի օրինակ xxxxxxxxx",
    password_error: 'Մուտքագրել առնվազն վեց սիմվոլ',
    username: "Լոգին",
    password: "Գաղտանբառ",
    login_accountant: "Մուտք գործել որպես աշխատակից",
    login_agent: "Մուտք գործել որպես Գործակալ",
    name_error: "Պետք է լինի ամենաքիչը 3 սինվոլ",
    select_error: "Ընտրել",
    empty_error: "Մուտքագրել տվյալներ",
    "user.first_name": "Անուն",
    "user.last_name": "Ազգանուն",
    "user.password": "Գաղտանբառ",
    "user.email": "Էլեկտրանային հասցե",
    message: "Հաղորդագրություններ",
    end_date: "Վերջնաժամկետ",
    name: "Առաջադրանքի վերնագիրը",
    text: "Առաջադրանքի բովանդակությունը",
    repeated_type: "Կրկնվելու հաճախականություն",
    repeated_value: "Oր",
    daily: "Օրական",
    weekly: "Շաբաթական",
    monthly: "Ամսական",
    annual: "Տարեկան",
    accountant_name: "Հաշվապահի անունը",
    respective_error: "Մուտքագրել նախորդ դաշտին համապատասխան տվյալներ",
    finish: "Ավարտվա՞ծ է",
    error_process: "Գործընթացը ձախողվել է",
    success_process: "Գործընթացը հաջողությամբ ավարտված է",
    duration: "Առաջադրանքի տևողությունը",
    change_status: "Փոխել առաջադրանքի վիճակը",
    active: "Ակտիվ",
    enter_message: "Մուտքագրել հաղորդագրություն",
    no_tasks: "Դեռ առաջադրանքներ չկան",
    no_dayoff: "Դեռ day off-ներ չկան",
    no_survey: "Դեռ Հարցուներ չկան",
    stop: "Դադար",
    notification: "Ծանուցում",
    edit_task: "Կատարել փոփոխություններ",
    edit: "Խմբագրել",
    no_changes: "Դուք կարող եք խմբագրել միայն ձեր կողմից ստեղծված առաջադրանքը",
    deadline: "Վերջնաժամկետ",
    reports: "Հաշվետվություն",
    upload_file: "Վերբեռնել ֆայլը",
    name_file: "Ֆայլի անվանումը",
    add_file: "Ավելացնել ֆայլ",
    change_data: "Այլ տվյալներ",
    type_of_service: "Ծառայության տեսակ",
    type_of_activity: "Գործունեության տեսակ",
    profession: "Մասնագիտություն",
    download:"Ներբեռնել Հաշվետվությունը"
}